// actions/access.js (DEMO)
import { ACCESS_LOADING, ACCESS_SUCCESS, ACCESS_FAIL } from "../constants/actionTypes";
import { fetchAccess as fetchAccessAPI, startDemoApi } from "../api";
import { setUser } from "./user";

/**
 * Check if a demo user exists for this browser.
 * - Calls GET /auth/access
 * - Does NOT create a user
 */
export const fetchAccess = () => async (dispatch) => {
  dispatch({ type: ACCESS_LOADING });

  try {
    const { data } = await fetchAccessAPI();

    // remember demo user id if it exists
    if (data?.demoUserId) {
      localStorage.setItem("demoUserId", data.demoUserId);
    } else {
      // no user -> ensure we don't keep stale id
      localStorage.removeItem("demoUserId");
    }

    // only set user if hasUser === true
    if (data?.hasUser && data?.user) {
      await dispatch(setUser(data.user));
    } else {
      await dispatch(setUser({})); // clear user
    }

    dispatch({
      type: ACCESS_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    dispatch({
      type: ACCESS_FAIL,
      payload: {
        error:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "ACCESS_FAIL",
      },
    });
    localStorage.removeItem("demoUserId");
    return null;
  }
};

/**
 * Start demo:
 * - Calls POST /auth/start-demo
 * - Creates a new demo user
 * - Sets user + access in Redux
 */
export const startDemo = () => async (dispatch) => {
  dispatch({ type: ACCESS_LOADING });

  try {
    const { data } = await startDemoApi();

    // save demo user id
    if (data?.demoUserId) {
      localStorage.setItem("demoUserId", data.demoUserId);
    }

    // set user in Redux
    if (data?.user) {
      await dispatch(setUser(data.user));
    }

    dispatch({
      type: ACCESS_SUCCESS,
      payload: data,
    });

    return { ok: true, data };
  } catch (error) {
    dispatch({
      type: ACCESS_FAIL,
      payload: {
        error:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "ACCESS_FAIL",
      },
    });
    return { ok: false, error };
  }
};